import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  color: var(--colors-grey-50);
  border-radius: 0.5rem;
`;
